const API_BASE_URL = (
  process.env.REACT_APP_ANINA_AUTH_API_URL ||
  "http://localhost:8000"
).replace(/\/$/, "");

const CSRF_INTENT = "anina-auth-v1";

export async function createStripeCheckoutSession(plan, interval) {
  const response = await fetch(
    `${API_BASE_URL}/billing/stripe/checkout`,
    {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Intent": CSRF_INTENT,
      },
      body: JSON.stringify({
        plan,
        interval,
      }),
    }
  );

  let payload = null;

  try {
    payload = await response.json();
  } catch (error) {
    payload = null;
  }

  if (!response.ok) {
    throw new Error(
      payload?.detail || "Unable to start Stripe Checkout."
    );
  }

  return payload;
}

export async function createStripeCustomerPortalSession() {
  const response = await fetch(
    `${API_BASE_URL}/billing/stripe/portal`,
    {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "X-CSRF-Intent": CSRF_INTENT,
      },
    }
  );

  let payload = null;

  try {
    payload = await response.json();
  } catch (error) {
    payload = null;
  }

  if (!response.ok) {
    throw new Error(
      payload?.detail || "Unable to open Stripe Customer Portal."
    );
  }

  return payload;
}
